<template>
  <v-container fill-height fluid pa-0 v-if="!loading">
    <v-row justify="center" no-gutters>
      <v-col cols="6">
        <page-heading :text="$t('general.journey_complete')" text-center></page-heading>
        <div class="text-center mb-5 mt-5" v-if="!content">
          {{$t('general.journey_complete_desc')}}
        </div>
        <ContentRenderer v-else :content="content"></ContentRenderer>
      </v-col>
    </v-row>
    <v-row justify="center" no-gutters>
      <v-col class="text-center">
        <v-btn color="secondary" @click="quit()">{{$t('general.quit')}}</v-btn>
        <br>
        <br>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ContentRenderer from "../content/ContentRenderer";
  import PageHeading from "../framework/PageHeading";
  export default {
    name: "JourneyComplete",
    components:{
      PageHeading,ContentRenderer
    },
    computed:{
      journey(){
        return this.$store.state.journey.journey;
      },
      content(){
        return this.journey.completecontent;
      }
    },
    data(){
      return {
        loading:false
      }
    },
    mounted(){
      this.loading=true;
      this.$store.dispatch('auth/completeRedirect').then(()=>{
        this.loading=false;
      }).catch(()=>{
        this.loading=false;
      });
    },
    methods:{
      quit(){
        this.$store.dispatch('auth/logout',{clearAssessmenttoken:true,navigate:false}).then(()=>{
          this.$router.replace({name:'Home'});
        });
      }
    }
  }
</script>

<style scoped>

</style>